import { styled } from "@mui/material/styles";
import { BSPBody1 } from "../BSPBody1";

export const PanelSectionTitle = styled(BSPBody1)`
  font-weight: 500;
  display: flex;
  align-items: center;
`;
